<template>
  <div id="page-container" class="side-trans-enabled sidebar-dark" :class="{ 'sidebar-o-xs': mobileMenu, 'sidebar-o': menu }">
    <div data-simplebar="init"></div>
    <Navbar @onToggleMenu="onToggleMobileMenu" />
    <TopHeader @onToggleMenu="onToggleMenu" />
    <main id="main-container">
      <!-- <div id="alert-container" class="alert alert-warning alert-dismissible">
        <i class="fa fa-exclamation-triangle mr-1"></i>
        We are currently rolling out a series of upgrades which may temporarily impact the performance of some features. If you require any urgent
        assistance, please contact us.
      </div> -->
      <router-view />
    </main>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

import TopHeader from '@/components/TopHeader';
import Navbar from '@/components/Navbar';

export default {
  name: 'AppMain',
  components: {
    TopHeader,
    Navbar
  },
  data() {
    return {
      menu: true,
      mobileMenu: false
    };
  },
  watch: {
    $route() {
      this.mobileMenu = false;
    }
  },
  mounted() {
    this.getPermissions();
  },
  methods: {
    ...mapActions({
      getPermissions: 'user/getPermissions'
    }),
    onToggleMenu() {
      this.menu = !this.menu;
      this.mobileMenu = true;
    },
    onToggleMobileMenu() {
      this.mobileMenu = !this.mobileMenu;
    }
  }
};
</script>
